<p-accordion>
    <p-accordionTab header="Source" [selected]="true">
      <p-table #db [value]="sourceList | orderBy: {property: 'name', direction: 1}" [scrollable]="true"
        scrollHeight="180px">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-col-6" >Name</th>
            <th class="p-col-2" >Is Active</th>
            <th class="p-col-2" >Is Default</th>
            <th class="p-col-2" >Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr>
            <td class="p-col-6">{{data.name}}</td>
            <td class="p-col-2">{{data.isActive ? answertypeConstants.Yes : answertypeConstants.No}}</td>
            <td class="p-col-2">
              <p-radioButton
                        [value]="true"
                        [(ngModel)]="data.isDefault"
                        (onClick)="makeIsDefault(data)"
                        [disabled]="!data.isActive || data.isDefault">
              </p-radioButton>
               &nbsp; {{data.isDefault ? answertypeConstants.Yes : answertypeConstants.No}}
            </td>
            <td class="p-col-2 action">
              <span class="btnBars p-mr-0" (click)="showEditCaseData(data, caseDataTypes[0])"
                pTooltip="Edit" tooltipPosition="top"><i class="pi
                  pi-pencil"></i></span>
              <span class="btnBars p-mr-0" (click)="delCaseSource(data)" pTooltip="Delete"
                tooltipPosition="top" *ngIf="!data.isDefault"><i class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">{{noDataFieldData}}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>

    <p-accordionTab header="Category">
      <app-case-fields-category
      [casesAllCategories]="casesAllCategories"
      (showEditCategory)="onShowEditCategory($event)"
      (reLoadCategories)="getCaseCategories()">
      </app-case-fields-category>
    </p-accordionTab>

    <p-accordionTab header="Priority">
      <p-table [value]="prioritiesList | orderBy: {property: 'name', direction: 1}" [scrollable]="true"
        scrollHeight="180px">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-col-6">Name</th>
            <th class="p-col-2" >Is Active</th>
            <th class="p-col-2" >Is Default</th>
            <th class="p-col-2">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr>
            <td class="p-col-6">{{data.name}}</td>
            <td class="p-col-2">{{data.isActive ? answertypeConstants.Yes : answertypeConstants.No}}</td>
            <td class="p-col-2">
              <p-radioButton
                        [value]="true"
                        [(ngModel)]="data.isDefault"
                        (onClick)="makeIsDefault(data)"
                        [disabled]="!data.isActive || data.isDefault">
              </p-radioButton>
               &nbsp; {{data.isDefault ? answertypeConstants.Yes : answertypeConstants.No}}
            </td>
            <td class="p-col-2 action">
              <span class="btnBars p-mr-0" (click)="showEditCaseData(data, caseDataTypes[2])"
                pTooltip="Edit" tooltipPosition="top"><i class="pi
                  pi-pencil"></i></span>
              <span class="btnBars p-mr-0" (click)="delCaseSource(data, 'Priority')" pTooltip="Delete"
                tooltipPosition="top" *ngIf="!data.isDefault"><i class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>

    <p-accordionTab header="Resolved Reason">
      <p-table [value]="resolvedReasons" [scrollable]="true"
        scrollHeight="180px">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-col-6">Name</th>
            <th class="p-col-2" >Is Active</th>
            <th class="p-col-2" >Is Default</th>
            <th class="p-col-2">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr>
            <td class="p-col-6">{{data.name}}</td>
            <td class="p-col-2">{{data.isActive ? answertypeConstants.Yes : answertypeConstants.No}}</td>
            <td class="p-col-2">
              <p-radioButton
                        [value]="true"
                        [(ngModel)]="data.isDefault"
                        (onClick)="makeIsDefaultResolvedUnresolved(data, caseDataTypes[3])"
                        [disabled]="!data.isActive || data.isDefault">
              </p-radioButton>
               &nbsp; {{data.isDefault ? answertypeConstants.Yes : answertypeConstants.No}}
            </td>
            <td class="p-col-2 action">
              <span class="btnBars p-mr-0" (click)="showEditCaseData(data, caseDataTypes[3])"
                pTooltip="Edit" tooltipPosition="top"><i class="pi
                  pi-pencil"></i></span>
              <span class="btnBars p-mr-0" (click)="deleteResolveUnresolved(data, caseDataTypes[3])" pTooltip="Delete"
                tooltipPosition="top" *ngIf="!data.isDefault"><i class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>

    <p-accordionTab header="Unresolved Reason">
      <p-table [value]="unResolvedReasons" [scrollable]="true"
        scrollHeight="180px">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-col-6">Name</th>
            <th class="p-col-2" >Is Active</th>
            <th class="p-col-2" >Is Default</th>
            <th class="p-col-2">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr>
            <td class="p-col-6">{{data.name}}</td>
            <td class="p-col-2">{{data.isActive ? answertypeConstants.Yes : answertypeConstants.No}}</td>
            <td class="p-col-2">
              <p-radioButton
                        [value]="true"
                        [(ngModel)]="data.isDefault"
                        (onClick)="makeIsDefaultResolvedUnresolved(data, caseDataTypes[4])"
                        [disabled]="!data.isActive || data.isDefault">
              </p-radioButton>
               &nbsp; {{data.isDefault ? answertypeConstants.Yes : answertypeConstants.No}}
            </td>
            <td class="p-col-2 action">
              <span class="btnBars p-mr-0" (click)="showEditCaseData(data, caseDataTypes[4])"
                pTooltip="Edit" tooltipPosition="top"><i class="pi
                  pi-pencil"></i></span>
              <span class="btnBars p-mr-0" (click)="deleteResolveUnresolved(data, caseDataTypes[4])" pTooltip="Delete"
                tooltipPosition="top" *ngIf="!data.isDefault"><i class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>

    <p-accordionTab header="Email To Case">
      <shared-email-to-module-record
        [channels]="allCaseChannels"
        [moduleName]="moduleName">

      </shared-email-to-module-record>
    </p-accordionTab>

  </p-accordion>

  <p-dialog header="{{addEditCaseHeader}}" [modal]="true" *ngIf="displayAddCaseData" [(visible)]="displayAddCaseData" [style]="{width: '50vw'}"
    [baseZIndex]="10000">
    <div class="p-grid">
      <div class="p-col-12" *ngIf="addEditCaseHeader == 'Add Field Data'">
        <label for="type">Fields Type <span style="color: red;">*</span></label>
        <p-dropdown [options]="caseDataTypes" [(ngModel)]="selectedCaseDataType" optionLabel="name"
          placeholder="Select Field Type" [ngClass]="{ 'p-invalid': formSubmitted && !selectedCaseDataType}"
          [ngModelOptions]="{standalone: true}" appendTo="body" #dataName="ngModel" required></p-dropdown>
          <small *ngIf="formSubmitted && !selectedCaseDataType" class="p-invalid">
            Fields Type is required
          </small>
      </div>
      <div class="p-col-12" *ngIf="addEditCaseHeader == 'Edit Field Data'">
        <div class="header">
          <h5 class="p-mb-0">Fields Name -- {{caseDataTypes[caseTypeId -1].name}}
            <p-inputSwitch
                        class="header-switch"
                        [(ngModel)]="caseDataTemp.isActive"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="caseDataTemp && caseDataTemp?.isDefault">
            </p-inputSwitch>
          </h5>
        </div>
      </div>
      <div class="p-col-12">
        <label for="name">Name <span style="color: red;">*</span></label>
        <input type="text" pInputText [(ngModel)]="caseDataTemp.name" (keyup)="onValidateName($event)" [ngModelOptions]="{standalone: true}"
          (blur)="onValidateName($event)" required >

        <!-- <small *ngIf="formSubmitted && !caseDataTemp?.name" class="p-invalid">
          Name is required || [ngClass]="{ 'p-invalid': formSubmitted == true ||
          invalidData == true || isDisabledFieldData == true}"
        </small> -->
        <small *ngIf="invalidData == true" class="p-invalid">
          Name exists in the list already
        </small>
        <small *ngIf="isDisabledFieldData == true" class="p-invalid">
          Name is required
        </small>
      </div>
      <div class="p-col-12">
        <label for="name">Description</label>
        <input type="text" pInputText style="width: 100%;" [(ngModel)]="caseDataTemp.description">
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton (click)="closeAddEditCaseFieldData()" label="Cancel" class="p-button-secondary"></button>
      <button pButton (click)="addEditCaseFieldData()" label="Save"></button>
    </ng-template>
  </p-dialog>

  <p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
